module.exports = "mutation deleteTrainingSave($id: Int!) {\n  deleteEntry(id: $id)\n}"